module.exports = __webpack_public_path__ + "img/stick_activites_marche.d35a46d3.svg";